import SplitPane from './split-pane.vue'

SplitPane.install = function (Vue) {
  Vue.component(SplitPane.name, SplitPane)
}
export default SplitPane
